/*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-SSW-7Q4M2 */
/* Shape Sleuth "Why it's right". Generated by build.py from why.js. */
window.SSWhy = (function(){
'use strict';
  /*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-SSW-7Q4M2 */
  /* host lock: only starts on our own hostnames; anywhere else it returns before the game is built.
     Allowed: shlc-tutor.co.uk + subdomains, the store myshopify host (theme previews), localhost, file://. */
  try { var __shlcH = String(location.hostname || '').toLowerCase();
    if (!(/(^|\.)shlc-tutor\.co\.uk$/.test(__shlcH) || __shlcH === 'c44a55-2.myshopify.com'
          || __shlcH === 'localhost' || __shlcH === '127.0.0.1' || __shlcH === '')) return;
  } catch (e) { return; }
  try { (window.SHLC_BUILD = window.SHLC_BUILD || {})['SSW'] = 'SHLC-SSW-7Q4M2'; } catch (e) {}
/* Shape Sleuth "Why it's right": what the page draws over an answered question (2026-10-04).
   build(q) is pure logic with no DOM: it reads the question the engine made (its cells, options, ruleKey and explain text)
   and returns what to draw, or null when the data cannot name a step exactly (the rule line is shown alone then).
   A label is only ever a property that really differs between two specs, so it can never invent a step.
   Built into assets/shape-sleuth-why.js by build.py; tests/why.mjs checks every label against the specs. */
var SSWhy = (function(){
'use strict';
var E = (typeof window !== 'undefined' && window.SSEngine) || null;
function use(engine){ E = engine; }
var MINUS = '−';
var FILL = { black: 'black', white: 'white', grey: 'grey', hatch: '↘ lines', hatch2: '↗ lines', dotfill: 'dot fill', crossfill: 'criss-cross', vstripe: 'stripes', checker: 'checks' };
var STROKE = { solid: 'solid edge', dash: 'dashed edge', dot: 'dotted edge' };
var SIZE = { s: 'small', m: 'medium', l: 'large' }, RANK = { s: 1, m: 2, l: 3 };
var SHAPE = { star6: '6-point star', quarter: 'quarter circle', ellipse: 'oval', tshape: 'T shape', zshape: 'Z shape', lshape: 'L shape', rtriangle: 'right triangle' };
var POS = { tl: 'top left', t: 'top', tr: 'top right', r: 'right', br: 'bottom right', b: 'bottom', bl: 'bottom left', l: 'left', c: 'middle' };
var RING = ['tl', 't', 'tr', 'r', 'br', 'b', 'bl', 'l'];
var KNOWN = ['shape', 'fill', 'size', 'rot', 'dots', 'lines', 'pos', 'inner', 'stroke', 'flip', 'pair', 'copies'];
function shapeName(s){ return SHAPE[s] || s; }
function count(n, one){ return n + ' ' + one + (n === 1 ? '' : 's'); }
function signed(d, one){ return (d > 0 ? '+' : MINUS) + count(Math.abs(d), one); }
function num(v){ return typeof v === 'number' ? v : 0; }
function same(a, b){ return JSON.stringify(a == null ? null : a) === JSON.stringify(b == null ? null : b); }
/* a turn of d degrees on this shape: hidden when the shape looks the same after it */
function turnLabel(d, shape){
  d = ((d % 360) + 540) % 360 - 180;
  var sym = (E && E.SYM && E.SYM[shape]) || 360;
  if (!d || sym === 1 || Math.abs(d) % sym === 0) return '';
  if (Math.abs(d) === 180) return 'turns 180°';
  return (d > 0 ? '↻ ' : '↺ ') + Math.abs(d) + '°';
}
/* the label for one property that differs between spec a and spec b ('' when it does not differ visibly);
   null means it differs in a way no short label can name exactly */
function fieldLabel(f, a, b){
  var x = a[f], y = b[f];
  if (f === 'dots' || f === 'lines'){ var d = num(y) - num(x); return d ? signed(d, f === 'dots' ? 'dot' : 'bar') : ''; }
  if (f === 'copies'){ var c = (y || 1) - (x || 1); return c ? signed(c, 'shape') : ''; }
  if (same(x, y)) return '';
  if (f === 'shape'){
    var S = (E && E.SIDES) || {};
    if (S[x] && S[y] && S[y] !== S[x]) return signed(S[y] - S[x], 'side');
    return shapeName(y);
  }
  if (f === 'fill') return FILL[y] || null;
  if (f === 'stroke') return STROKE[y || 'solid'] || null;
  if (f === 'size') return RANK[y] && RANK[x] ? (RANK[y] > RANK[x] ? 'bigger' : 'smaller') : null;
  if (f === 'rot') return turnLabel(num(y) - num(x), b.shape);
  if (f === 'flip') return !!x === !!y && !x ? '' : 'flips';
  if (f === 'pos'){
    var i = RING.indexOf(x), j = RING.indexOf(y);
    if (i < 0 || j < 0) return 'moves';
    var s = (j - i + 8) % 8;
    return s === 4 ? 'moves' : s < 4 ? 'moves ↻' : 'moves ↺';
  }
  if (f === 'inner'){ if (x && !y) return 'loses inside'; if (!x && y) return 'gains inside'; return null; }
  return null;
}
/* every visible change from a to b, in a fixed order; null if any change cannot be named */
function diff(a, b){
  var keys = {}, out = [], k;
  for (k in a) keys[k] = 1;
  for (k in b) keys[k] = 1;
  for (k in keys) if (KNOWN.indexOf(k) < 0 && !same(a[k], b[k])) return null;
  for (var i = 0; i < KNOWN.length; i++){
    var l = fieldLabel(KNOWN[i], a, b);
    if (l === null) return null;
    if (l) out.push(l);
  }
  return out;
}
/* a value as a chip says it ("grey", "2 dots") */
function valText(f, s){
  var v = s[f];
  if (f === 'fill') return FILL[v] || null;
  if (f === 'dots') return num(v) ? count(num(v), 'dot') : 'no dots';
  if (f === 'lines') return num(v) ? count(num(v), 'bar') : 'no bars';
  if (f === 'size') return SIZE[v] || null;
  if (f === 'stroke') return STROKE[v || 'solid'] || null;
  if (f === 'copies') return count(v || 1, 'shape');
  if (f === 'shape') return shapeName(v);
  if (f === 'rot') return num(v) ? 'turned ' + num(v) + '°' : 'not turned';
  if (f === 'flip') return v ? 'mirror image' : 'same way';
  if (f === 'inner') return v ? 'copy inside' : 'nothing inside';
  if (f === 'pos') return POS[v || 'c'] || null;
  return null;
}
/* the parts of a ruleKey that are one plain property, so a chip can name the shared value */
var SIMPLE = ['fill', 'dots', 'lines', 'size', 'stroke', 'copies', 'shape', 'rot', 'flip', 'inner'];
function parts(q){ return String(q.ruleKey || '').split('+').filter(function(p){ return SIMPLE.indexOf(p) >= 0; }); }
function key(f, s){ return f === 'inner' ? !!s.inner : f === 'flip' ? !!s.flip : f === 'copies' ? (s.copies || 1) : f === 'dots' || f === 'lines' || f === 'rot' ? num(s[f]) : (s[f] == null ? null : s[f]); }
/* series, analogy: an arrow per step with every change; one change that cannot be named drops the lot */
function steps(seq, pairs){
  var out = [];
  for (var i = 0; i < pairs.length; i++){
    var d = diff(seq[pairs[i][0]], seq[pairs[i][1]]);
    if (!d) return null;
    out.push({ i: pairs[i][0], j: pairs[i][1], labels: d });
  }
  if (!out.some(function(s){ return s.labels.length; })) return null;
  /* a change made at every step is said once ("Every step: +1 dot"); the arrows keep the changes that vary. A
     single change made every time stays on the arrows, as the concept draws it */
  var every = out[0].labels.filter(function(l){ return out.every(function(s){ return s.labels.indexOf(l) >= 0; }); });
  if (every.length === 1 && out.every(function(s){ return s.labels.length === 1; })) every = [];
  out.forEach(function(s){ s.labels = s.labels.filter(function(l){ return every.indexOf(l) < 0; }); });
  return { steps: out, every: every };
}
/* matrix: the ruleKey says which property steps along the rows ("dots across") or down the columns; it is shown
   only when that property makes the same change at every one of the six steps */
var MXF = { sides: 'shape', dots: 'dots', turn: 'rot', move: 'pos', bigger: 'size', 'more shapes': 'copies', darker: 'fill' };
function axes(q, g){
  var out = { across: null, down: null }, any = false;
  String(q.ruleKey || '').split(/,\s*/).forEach(function(p){
    var m = p.match(/^(.+) (across|down)$/), f = m && MXF[m[1]];
    if (!f) return;
    var labels = [];
    for (var r = 0; r < 3; r++) for (var c = 0; c < 2; c++){
      var a = m[2] === 'across' ? g[r * 3 + c] : g[c * 3 + r], b = m[2] === 'across' ? g[r * 3 + c + 1] : g[(c + 1) * 3 + r];
      labels.push(fieldLabel(f, a, b));
    }
    if (labels[0] && labels.every(function(l){ return l === labels[0]; })){ out[m[2]] = labels[0]; any = true; }
  });
  return any ? out : null;
}
/* odd one out: the four share a value the odd one does not */
function odd(q){
  var o = q.options, c = q.correct, res = null;
  parts(q).forEach(function(f){
    if (res) return;
    var rest = o.filter(function(_, i){ return i !== c; }), v = key(f, rest[0]);
    if (!rest.every(function(s){ return same(key(f, s), v); }) || same(key(f, o[c]), v)) return;
    var t = valText(f, rest[0]), r = valText(f, o[c]);
    if (t && r && t !== r) res = { kind: 'odd', field: f, chip: t, ring: r };
  });
  return res;
}
/* complete the set, most like: every shape in the set (or the pair) and the answer share these values */
function shared(q, kind){
  var group = q.prompt.cells.concat([q.options[q.correct]]), got = [];
  parts(q).forEach(function(f){
    var v = key(f, group[0]);
    if (!group.every(function(s){ return same(key(f, s), v); })) return;
    if (f === 'inner' && !v) return;
    var t = valText(f, group[0]);
    if (t) got.push({ field: f, text: t });
  });
  return got.length ? { kind: kind, items: got } : null;
}
/* codes: the engine's own explain names what each letter stands for; letters are read off the examples and
   checked both ways (one letter, one value) before they are shown */
var CODEF = { 'the number of dots': 'dots', 'the outline style': 'stroke', 'the shading': 'fill', 'the position in the box': 'pos', 'the rotation': 'rot', 'the size': 'size', 'the shape': 'shape' };
function codes(q){
  var P = q.prompt, legend = [], ok = true;
  String(q.explain || '').split(/<br\s*\/?>/i).forEach(function(line){
    var m = line.trim().match(/^(\d)(?:st|nd|rd|th) letter = (.+?)\.?$/), f = m && CODEF[m[2]];
    if (!f){ if (m) ok = false; return; }
    var k = +m[1] - 1, byL = {}, byV = {};
    var add = function(letter, s){
      var t = valText(f, s), v = JSON.stringify(key(f, s));
      if (!letter || !t) { ok = false; return; }
      if ((byL[letter] && byL[letter].v !== v) || (byV[v] && byV[v] !== letter)) ok = false;
      byL[letter] = { v: v, text: t }; byV[v] = letter;
    };
    P.cells.forEach(function(s, i){ add(String(P.codes[i])[k], s); });
    add(String(q.options[q.correct])[k], P.test);
    legend.push({ k: k, field: f, items: Object.keys(byL).sort().map(function(l){ return { letter: l, text: byL[l].text }; }) });
  });
  return ok && legend.length ? { kind: 'codes', legend: legend } : null;
}
/* nets: opposite faces, folded from where each face sits in the drawn net */
function foldPairs(html){
  var svg = String(html || '').match(/<svg[^>]*aria-label=['"]cube net['"][\s\S]*?<\/svg>/);
  if (!svg) return null;
  var re = /<g transform=['"]translate\((\d+) (\d+)\)['"]>\s*<rect x=['"]3['"] y=['"]3['"] width=['"]94['"]/g, m, cells = [];
  while ((m = re.exec(svg[0]))) cells.push([+m[1] / 100, +m[2] / 100]);
  if (cells.length !== 6) return null;
  var at = {}, seen = {}, normal = [];
  cells.forEach(function(c, i){ at[c[0] + ',' + c[1]] = i; });
  var neg = function(v){ return [-v[0], -v[1], -v[2]]; };
  var stack = [[0, [0, 0, -1], [1, 0, 0], [0, 1, 0]]];
  seen[0] = 1;
  while (stack.length){
    var t = stack.pop(), i = t[0], n = t[1], u = t[2], v = t[3], c = cells[i];
    normal[i] = n;
    [[1, 0, u, neg(n), v], [-1, 0, neg(u), n, v], [0, 1, v, u, neg(n)], [0, -1, neg(v), u, n]].forEach(function(s){
      var j = at[(c[0] + s[0]) + ',' + (c[1] + s[1])];
      if (j === undefined || seen[j]) return;
      seen[j] = 1;
      stack.push([j, s[2], s[0] ? s[3] : s[3], s[0] ? s[4] : s[4]]);
    });
  }
  if (normal.filter(Boolean).length !== 6) return null;
  var pairs = [], used = {};
  for (var a = 0; a < 6; a++) for (var b = a + 1; b < 6; b++)
    if (!used[a] && !used[b] && normal[a].every(function(x, k){ return x === -normal[b][k]; })){ pairs.push([a, b]); used[a] = used[b] = 1; }
  return pairs.length === 3 ? pairs : null;
}
/* PLAN 10: why the picked card is not the answer, from the specs. Returns { letter, kind, parts } and a sentence;
   every part names a value the pick (or the answer) really has, so tests can re-read it. null when it cannot. */
var ORDINAL = ['1st', '2nd', '3rd', '4th'];
/* a value with the verb that reads right: "has 3 bars", "is grey", "has a dashed edge", "is an oval" */
function phrase(f, t){
  if (f === 'dots' || f === 'lines' || f === 'copies') return 'has ' + t;
  if (f === 'stroke') return 'has a ' + t;
  if (f === 'inner') return t === 'copy inside' ? 'has a copy inside' : 'has ' + t;
  if (f === 'fill') return /^(black|white|grey)$/.test(t) ? 'is ' + t : 'has ' + t;
  if (f === 'shape') return 'is ' + (/^[aeiou]/.test(t) ? 'an ' : 'a ') + t;
  if (f === 'pos') return 'is ' + (t === 'middle' ? 'in the middle' : 'at the ' + t);
  if (f === 'flip') return t === 'mirror image' ? 'is a mirror image' : 'faces the same way';
  return 'is ' + t;
}
function whyNot(q, pick){
  if (!q || pick == null || pick < 0 || pick === q.correct || !q.options[pick]) return null;
  var L = 'ABCDE'.charAt(pick), ans = q.options[q.correct], o = q.options[pick], P = q.prompt, w;
  try {
    if (q.type === 'codes'){
      w = build(q);
      if (!w) return null;
      for (var g = 0; g < w.legend.length; g++){
        var G = w.legend[g], k = G.k, have = String(o)[k], need = String(ans)[k];
        if (have === need) continue;
        var meant = G.items.filter(function(it){ return it.letter === have; })[0], shape = valText(G.field, P.test);
        if (!meant || !shape) continue;
        return { letter: L, kind: 'codes', parts: [{ k: k, letter: have, field: G.field, means: meant.text, shape: shape }],
          text: ORDINAL[k] + ' letter: ' + have + ' is ' + meant.text + ', this shape is ' + shape + '.' };
      }
      return null;
    }
    if (typeof o !== 'object' || typeof ans !== 'object' || !o.shape) return null;
    if (q.type === 'odd'){
      w = build(q);
      if (!w || valText(w.field, o) !== w.chip) return null;
      return { letter: L, kind: 'odd', parts: [{ field: w.field, pick: w.chip }], text: L + ' ' + phrase(w.field, w.chip) + ', like three others.' };
    }
    if (q.type === 'like' || q.type === 'mostlike'){
      w = build(q);
      if (!w) return null;
      for (var i = 0; i < w.items.length; i++){
        var it = w.items[i], has = valText(it.field, o);
        if (has && has !== it.text) return { letter: L, kind: 'set', parts: [{ field: it.field, pick: has, need: it.text }], text: L + ' ' + phrase(it.field, has) + ', not ' + it.text + '.' };
      }
      return null;
    }
    /* sequences, analogies, matrices: what the pick has that the answer does not, at most two things */
    if (!same(o.pair, ans.pair)) return null;
    var parts = [];
    ['dots', 'lines', 'fill', 'size', 'stroke', 'copies', 'shape', 'rot', 'flip', 'inner', 'pos'].forEach(function(f){
      if (parts.length >= 2 || same(key(f, o), key(f, ans))) return;
      if (f === 'rot' && !turnLabel(num(o.rot) - num(ans.rot), ans.shape)) return;
      var a = valText(f, o), b = valText(f, ans);
      if (a && b && a !== b) parts.push({ field: f, pick: a, need: b });
    });
    if (!parts.length) return null;
    return { letter: L, kind: 'diff', parts: parts, text: L + ': ' + parts.map(function(p){ return p.pick; }).join(', ') + '. The answer: ' + parts.map(function(p){ return p.need; }).join(', ') + '.' };
  } catch (e) { return null; }
}
function build(q){
  if (!q || !q.prompt) return null;
  var P = q.prompt, ans = q.options[q.correct];
  try {
    if (q.type === 'series'){
      var seq = P.cells.map(function(c, i){ return i === P.missing ? ans : c; }), pr = [];
      for (var i = 0; i + 1 < seq.length; i++) pr.push([i, i + 1]);
      var s = steps(seq, pr);
      return s && { kind: 'steps', board: 'series', steps: s.steps, every: s.every };
    }
    if (q.type === 'analogy'){ var a = steps([P.cells[0], P.cells[1], P.cells[2], ans], [[0, 1], [2, 3]]); return a && { kind: 'steps', board: 'analogy', steps: a.steps, every: a.every }; }
    if (q.type === 'matrix'){ var g = P.cells.map(function(c, i){ return i === P.missing ? ans : c; }), x = axes(q, g); return x && { kind: 'axes', across: x.across, down: x.down }; }
    if (q.type === 'odd') return odd(q);
    if (q.type === 'like') return shared(q, 'like');
    if (q.type === 'mostlike') return shared(q, 'mostlike');
    if (q.type === 'codes') return codes(q);
    if (q.type === 'hidden') return q.revealSvg ? { kind: 'hidden' } : null;
    if (q.type === 'nets'){ var np = foldPairs(P.html); return np && { kind: 'nets', pairs: np }; }
  } catch (e) {}
  return null;
}
/* ===== drawing (browser only) =====
   Moved here from the page template (2026-10-04) to keep the template under its size guard. strip() draws under
   the question board, after() rings the card and colours the code letters once the answers are marked. */
function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
var WC = ['#F47820', '#2F6FD6', '#8A4FD8'];
/* the turn arrows are drawn: the game's fonts have no ↻ or ↺ */
var TURN = function(cw){ return '<svg class="ss-wturn" width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"' + (cw ? '' : ' style="transform:scaleX(-1)"') + '><path d="M19 12a7 7 0 1 1-2.1-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M20.5 3v6.5H14z" fill="currentColor"/></svg>'; };
function wtext(t){ return esc(t).replace('\u21bb', TURN(true)).replace('\u21ba', TURN(false)); }
function wsay(t){ return String(t).replace('\u21bb', 'clockwise').replace('\u21ba', 'anticlockwise'); }
var ARROWHEAD = function(x, y, dx, dy){
  var L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L, s = 7;
  return '<path d="M' + x.toFixed(1) + ' ' + y.toFixed(1) + 'L' + (x - s * ux - s * 0.6 * uy).toFixed(1) + ' ' + (y - s * uy + s * 0.6 * ux).toFixed(1) +
    'L' + (x - s * ux + s * 0.6 * uy).toFixed(1) + ' ' + (y - s * uy - s * 0.6 * ux).toFixed(1) + 'Z" fill="#F47820"/>';
};
function strip(el, q, z){
  var w = z.why;
  /* anything drawn under the board (a view, or only the pick's reason) stacks below it */
  el.classList.toggle('has-why', !!w && w.kind !== 'hidden');
  el.setAttribute('data-why', w ? (w.kind === 'not' ? 'not' : w.less ? 'less' : 'full') : 'none');
  if (!w) return;
  var line = function(lbl, inner){ return '<p class="ss-wline">' + (lbl ? '<span class="ss-wlbl">' + lbl + '</span>' : '') + inner + '</p>'; };
  var chip = function(t, cls){ return '<b class="ss-wchip' + (cls ? ' ' + cls : '') + '">' + wtext(t) + '</b>'; };
  var arrow = function(down){ return '<svg class="ss-warr" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">' + (down ? '<path d="M12 3v13" stroke="#F47820" stroke-width="3" stroke-linecap="round"/><path d="M5 13l7 9 7-9z" fill="#F47820"/>' : '<path d="M3 12h13" stroke="#F47820" stroke-width="3" stroke-linecap="round"/><path d="M13 5l9 7-9 7z" fill="#F47820"/>') + '</svg>'; };
  var h = '';
  /* a wrapped board (phones): arcs under it would point at the wrong row, so the changes read in order instead */
  if (w.kind === 'steps' && z.wrap){
    var anyStep = w.steps.some(function(s){ return s.labels.length; });
    var seq = w.board === 'analogy'
      ? w.steps.map(function(s, k){ return s.labels.length ? line(k ? 'Bottom pair' : 'Top pair', s.labels.map(function(t){ return chip(t); }).join('')) : ''; }).join('')
      : line('Step by step', w.steps.map(function(s){ return s.labels.length ? chip(s.labels.join(', ')) : chip('no other change', 'is-quiet'); }).join('<span class="ss-wthen" aria-hidden="true">\u203a</span>'));
    h = '<div class="ss-why" role="note">' + (anyStep ? seq : '') + (w.every.length ? line(w.board === 'analogy' ? 'Both times' : 'Every step', w.every.map(function(t){ return chip(t); }).join('')) : '') + '</div>';
  }
  /* arrows: when every arrow can carry the whole change (two labels at most), the changes made at every step go on
     the arrows too, as the concept draws "+1 dot" on each, and no "Every step" line is written */
  else if (w.kind === 'steps' && !w.less && w.every.length && w.steps.every(function(s){ return s.labels.length + w.every.length <= 2; })){
    w = { kind: 'steps', board: w.board, every: [], merged: true, steps: w.steps.map(function(s){ return { i: s.i, j: s.j, labels: s.labels.concat(w.every) }; }) };
    z.why = w;
    return strip(el, q, z);
  }
  else if (w.kind === 'steps') h = '<div class="ss-why ss-why-steps" role="note" aria-label="' + esc(w.steps.map(function(s){ return wsay(s.labels.join(', ') || 'next'); }).join('; ')) + '"><svg class="ss-warcs" aria-hidden="true"></svg>' +
    w.steps.map(function(s, k){ return s.labels.length ? '<span class="ss-wl" data-k="' + k + '">' + s.labels.map(wtext).join('<br>') + '</span>' : ''; }).join('') + '</div>' +
    (w.every.length ? '<div class="ss-why ss-wevery" role="note">' + line(w.board === 'analogy' ? 'Both times' : 'Every step', w.every.map(function(t){ return chip(t); }).join('')) + '</div>' : '');
  else if (w.kind === 'axes') h = '<div class="ss-why" role="note">' + (w.across ? line('Each row', arrow(false) + chip(w.across)) : '') + (w.down ? line('Each column', arrow(true) + chip(w.down)) : '') + '</div>';
  else if (w.kind === 'odd') h = '<div class="ss-why" role="note">' + line('Four are', chip(w.chip)) + line('The odd one', chip(w.ring, 'is-key')) + '</div>';
  else if (w.kind === 'like' || w.kind === 'mostlike') h = '<div class="ss-why" role="note">' + line(w.kind === 'like' ? 'Every one' : 'Both', w.items.map(function(it){ return chip(it.text); }).join('')) + '</div>';
  else if (w.kind === 'codes') h = '<div class="ss-why" role="note">' + w.legend.map(function(g){
    return line('', g.items.map(function(it){ return '<span class="ss-wcode"><b style="color:' + WC[g.k % 3] + '">' + esc(it.letter) + '</b> ' + esc(it.text) + '</span>'; }).join(''));
  }).join('') + '</div>';
  else if (w.kind === 'nets'){
    var faces = el.querySelectorAll('svg[aria-label="cube net"] > g');
    if (faces.length === 6) w.pairs.forEach(function(p, k){ p.forEach(function(i){ faces[i].insertAdjacentHTML('beforeend', '<circle class="ss-wdot" cx="84" cy="16" r="11" fill="' + WC[k] + '" stroke="#1A2347" stroke-width="3"></circle>'); }); });
    h = faces.length === 6 ? '<div class="ss-why" role="note">' + line('', '<span class="ss-wpairs">' + WC.map(function(c){ return '<i style="background:' + c + '"></i>'; }).join('') + '</span>Same colour: opposite faces') + '</div>' : '';
  }
  /* the picked card's reason is the screen's one sentence, written by the page (rule list or teach card), not here */
  if (!h) return;
  el.insertAdjacentHTML('beforeend', h);
  if (w.kind === 'steps' && !z.wrap) arcs(el, w);
}
/* the step arrows: an orange arc under each pair of cells, its head along the curve, the change written under it */
function arcs(el, w){
  var strip = el.querySelector('.ss-why-steps'), cells = el.querySelectorAll('.ss-pbox .ss-pc');
  if (!strip || cells.length < 2) return;
  var sr = strip.getBoundingClientRect(), d = '', heads = '', bottom = 0, placed = [];
  var cx = function(i){ var r = cells[i].getBoundingClientRect(); return r.left + r.width / 2 - sr.left; };
  var hits = function(r){ return placed.some(function(p){ return Math.min(r.right, p.right) - Math.max(r.left, p.left) > -3 && Math.min(r.bottom, p.bottom) - Math.max(r.top, p.top) > -2; }); };
  w.steps.forEach(function(s, k){
    var x1 = cx(s.i) + 6, x2 = cx(s.j) - 6, mx = (x1 + x2) / 2, depth = Math.min(16, 6 + (x2 - x1) / 8);
    d += 'M' + x1.toFixed(1) + ' 2Q' + mx.toFixed(1) + ' ' + (2 + 2 * depth).toFixed(1) + ' ' + x2.toFixed(1) + ' 2';
    heads += ARROWHEAD(x2, 2, x2 - mx, 2 - (2 + 2 * depth));
    var lb = strip.querySelector('.ss-wl[data-k="' + k + '"]');
    if (!lb) return;
    /* a label never wraps inside a word (that made it taller and the board smaller on every pass); labels that
       would touch drop to another row instead, and stay inside the strip */
    lb.style.left = Math.max(lb.offsetWidth / 2, Math.min(sr.width - lb.offsetWidth / 2, mx)) + 'px';
    /* each label takes the highest row where it touches no label already placed */
    var top = depth + 8, r;
    for (var tries = 0; tries < 6; tries++){
      lb.style.top = top + 'px'; r = lb.getBoundingClientRect();
      if (!hits(r)) break;
      top += r.height + 3;
    }
    placed.push(r);
    bottom = Math.max(bottom, r.bottom - sr.top);
  });
  var svg = strip.querySelector('.ss-warcs');
  svg.setAttribute('width', Math.ceil(sr.width)); svg.setAttribute('height', 40);
  svg.innerHTML = '<path d="' + d + '" fill="none" stroke="#F47820" stroke-width="3" stroke-linecap="round"/>' + heads;
  strip.style.height = Math.ceil(Math.max(bottom, 22) + 2) + "px";
}
/* after the marks: ring the card the rule points at, colour the code letters to match the legend */
function after(el, opts, q, z){
  var w = z.why;
  if (!w) return;
  if (w.kind === 'odd' || w.kind === 'like' || w.kind === 'mostlike'){ var b = opts.querySelector('.ss-opt[data-i="' + q.correct + '"]'); if (b) b.classList.add('ss-wring'); }
  if (w.kind === 'codes'){
    var col = {}; w.legend.forEach(function(g){ col[g.k] = WC[g.k % 3]; });
    el.querySelectorAll('.ss-code').forEach(function(c){
      c.innerHTML = c.textContent.split('').map(function(ch, k){ return col[k] ? '<span style="color:' + col[k] + '">' + esc(ch) + '</span>' : esc(ch); }).join('');
    });
  }
}

return { strip: strip, after: after, whyNot: whyNot, use: use, build: build, diff: diff, fieldLabel: fieldLabel, valText: valText, foldPairs: foldPairs, FILL: FILL, STROKE: STROKE, SIZE: SIZE, POS: POS };
})();

return SSWhy;
})();
